<div class="dialog-container">
  <div class="dimmer"></div>
    <div class="message-box">
      <div class="dialogHeader" [ngClass]="dialogClass">
        <span *ngIf="icon"><img src="assets/ic-ui-warning-24.svg" alt="" style="width: 16px;"></span>
        <div [ngClass]="icon?'icon-title':'title'"  class="title">{{titleText}}</div>
        <div class="close"><img src="assets/images/cancel_24.svg" alt=""  (click)="closeDialog()" style="width: 16px; position: relative; top: 2px;" ></div>
       </div>
      <div class="children"><ng-content></ng-content></div>
      <div class="actions">
        <button mis-button (click)="dismiss()" *ngIf="type === 'confirm'" type="none" size="sm" class="button">
          {{dismissText}}
        </button>
        <button mis-button (click)="approve()" type="primary" size="sm" class="ml-16">
          {{approveText}}
        </button>
        <!-- <button class="mr-10" type="plainText" *ngIf="type === 'confirm'" text="{{dismissText}}" (clickCallback)="dismiss()"></app-button> -->
        <!-- <button type="primaryFilled" text="{{approveText}}" (clickCallback)="approve()"></app-button> -->
      </div>
    </div>
</div>
<!-- <div class="modal-wrapper">
  <p class="header-title">{{titleText}}</p>
  <div class="spinner-wrapper">
    <div class="html-spinner"></div>
  </div>
  <p class="footer-text">Please wait while we are processing your request. Do not refresh or go back.</p>
</div> -->
